import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OperationType } from "@app/tool/model/operationType.model";
import { TableConfig } from "@app/shared/util/table-config.utils";

@Component({
    selector: 'app-operation-types-table',
    templateUrl: './operation-types-table.component.html',
    styleUrls: ['./operation-types-table.component.scss']
})
export class OperationTypesTableComponent {
    @Input() operationTypes: OperationType[] = [];
    @Input() tableConfig: TableConfig;
    @Input() isLoading: false;
    @Input() headerBackgroundColor: string;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() rowClick = new EventEmitter<any>();

    onPageChange(tableConfig: TableConfig) {
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this.filterChange.emit(tableConfig);
    }

    onRowClick(clickedItem) {
        this.rowClick.emit(clickedItem);
    }
}
